import React from 'react';
import { useMedicalIssuerBuild } from './useMedicalIssuerBuild';
import { IssuerCoverageBuilder } from 'src/features/issuerCoverageBuilder/IssuerCoverageBuilder';

export const MedicalPlans = () => {
  const { build } = useMedicalIssuerBuild();

  return <IssuerCoverageBuilder build={build} />;
};
